import Toast from "@/helpers/Toast";

let warningTimer = null;
let logoutTimer = null;

export const clearSessionTimers = () => {
  if (warningTimer) clearTimeout(warningTimer);
  if (logoutTimer) clearTimeout(logoutTimer);
};

export const scheduleSessionTimers = (expiresAt, store, router) => {
  clearSessionTimers();

  if (!expiresAt) return;

  const now = Date.now();
  const timeLeft = expiresAt - now;

  if (timeLeft <= 0) return;

  // const warnAt = timeLeft - 60 * 1000; // 1 minute
  const warnAt = timeLeft - 5 * 60 * 1000; // 5 minutes

  if (warnAt > 0) {
    warningTimer = setTimeout(() => {
      Toast.fire({
        icon: "warning",
        title: "Your session will expire in 5 minutes.",
      });
    }, warnAt);
  }

  // 🚪 Auto logout at expiration
  logoutTimer = setTimeout(() => {
    store.commit("auth/clearUser");
    router.push("/login");

    Toast.fire({
      icon: "info",
      title: "Your session has expired. Please log in again.",
    });
  }, timeLeft);
};
